import EnterpriseList from '../../views/enterprise/EnterpriseList';
import EnterpriseCreateOrUpdate from '../../views/enterprise/EnterpriseCreateOrUpdate';
import { isCanAction } from "@/router/permission";

export default [
    {
        path: '/enterprise/list',
        name: 'enterprise-list',
        component: EnterpriseList,
        meta: { isAuthRequired: true }
    },
    {
        path: '/enterprise/create',
        name: 'enterprise-create',
        component: EnterpriseCreateOrUpdate,
        beforeEnter: isCanAction,
        meta: { isAuthRequired: true }
    },
    {
        path: '/enterprise/update',
        name: 'enterprise-update',
        component: EnterpriseCreateOrUpdate,
        beforeEnter: isCanAction,
        meta: { isAuthRequired: true }
    },
];